export function staticDitherValue(x: number, y: number): number {
  const seed = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
  return seed - Math.floor(seed);
}

export function staticDitherIndex(x: number, y: number, paletteLength: number): number {
  if (paletteLength <= 0) {
    return 0;
  }
  return Math.min(paletteLength - 1, Math.floor(staticDitherValue(x, y) * paletteLength));
}
